import { Nomenclature } from '@feature/nomenclature';
import { IdentityRequest } from '@feature/utils';

export interface Publisher {
  id: number;
  title: string;
}

export const peerReviewTypeList = ['YES', 'NO'] as const;
export type PeerReviewType = (typeof peerReviewTypeList)[number];

export const prestigeTypeList = ['YES', 'NO'] as const;
export type PrestigeType = (typeof prestigeTypeList)[number];

export interface Publisher {
  id: number;
  title: string;
  address: string;
  type: Nomenclature;
  prestige?: PrestigeType | null;
  peerReview?: PeerReviewType | null;
}

export interface PublisherRequest {
  title: string;
  address: string;
  type: IdentityRequest;
  prestige?: PrestigeType | null;
  peerReview?: PeerReviewType | null;
}
